module.exports = __webpack_public_path__ + "31d0fa9edbde0b5fdfd65f82a6c92509.MP3";